import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from "react";
import { FileStatus } from "../../constants/FileStatus";
import { FileStatusIconCompleted } from "./FileStatusIconCompleted";
import { FileStatusIconErrored } from "./FileStatusIconErrored";
import { FileStatusIconPaused } from "./FileStatusIconPaused";
import { FileStatusIconProgressing } from "./FileStatusIconProgressing";
export const FileStatusIcon = /*#__PURE__*/ memo((param)=>{
    let { status } = param;
    switch(status){
        case FileStatus.completed:
            return /*#__PURE__*/ _jsx(FileStatusIconCompleted, {});
        case FileStatus.paused:
            return /*#__PURE__*/ _jsx(FileStatusIconPaused, {});
        case FileStatus.errored:
            return /*#__PURE__*/ _jsx(FileStatusIconErrored, {});
        case FileStatus.progressing:
        default:
            return /*#__PURE__*/ _jsx(FileStatusIconProgressing, {});
    }
});
FileStatusIcon.displayName = "FileStatusIcon";
